import { connect } from 'react-redux';
import {actions as navigationActions} from '../../navigation';
import { ZWebAuthenticated } from '../../../services';

const mapDispatchToProps = (dispatch) => ({
    logout: () => { dispatch(ZWebAuthenticated.actions.logout()) },
    selectEntity: () => { dispatch(navigationActions.navigate('/select-entity')) }
});
export default connect(null, mapDispatchToProps)(ZWebAuthenticated.components.UserPopover)